import Spinner from 'Components/Spinner';
import { Suspense } from 'react';

export const suspense = (Component: React.ReactNode) => (
  <Suspense fallback={<></>} children={Component} />
);
